import React from "react";
import PFlogo from "images/logo-dark.png";
import radioImage from "images/login/loginElement.svg";
import loginBackground from "images/login/loginBackground.svg";
import styles from "./styles.module.scss";

export const starterLicencePlan = () => {

  return (
    <>
      <div className={styles.container}>
        <img alt="Paperflite Logo" className={styles.logo} src={PFlogo} />
        <img alt="Radio Logo" className={styles.logos} src={radioImage} />
      </div>
      <h1 className={styles.heading}>Almost there! </h1>

      <div className={styles.contentContainer}>
        <div className={styles.subText}>
          <p className={styles.text}>
            {" "}
            But it looks like you’ve got a Starter seat, which doesn’t cover the
            chrome extension. Reach out to your admin for a quick seat upgrade.
          </p>
        </div>
      </div>
      <div>
        <img
          alt="Half head man with audio waves in the background"
          className={styles.backgroundImage}
          src={loginBackground}
        />
      </div>
    </>
  );
};

export default starterLicencePlan;
